import { z } from 'zod';
/** Stable identifiers for the two legal documents the app manages. */
export const LEGAL_SLUGS = ['privacy_policy', 'consent'];
export const legalSlugSchema = z.enum(LEGAL_SLUGS);
export const legalDocumentDtoSchema = z.object({
    slug: legalSlugSchema,
    title: z.string(),
    content: z.string(),
    version: z.string(),
    updatedAt: z.string(),
});
/** Admin update — all three fields optional so a typo fix doesn't have to
 *  rewrite the version stamp. Bumping `version` re-prompts every user. */
export const updateLegalDocumentSchema = z.object({
    title: z.string().trim().min(1).max(200).optional(),
    content: z.string().min(1).optional(),
    version: z.string().trim().min(1).max(50).optional(),
});
